export const loginChallengeTypes = Object.freeze({
  SOFTWARE_TOKEN_MFA_CODE: 'SOFTWARE_TOKEN_MFA_CODE',
  SMS_MFA_CODE: 'SMS_MFA_CODE',
})

export const loginChallengeNames = Object.freeze({
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  SMS_MFA: 'SMS_MFA',
})
